'use client';

/**
 * @module
 * @category Component
 */

import { Status } from '@bomdisoft/components';
import { getLanguageFromLocale } from '@bomdisoft/translations';
import s from '@pieleaf/shared/products-chips/styles.module.css';
import { productsText } from '@pieleaf/translations';
import { useParams } from 'next/navigation';

export type ProductsChipsProps = {
  products: PageProduct[];
  className?: string;
  holderClassName?: string;
};

export const ProductsChips = ({ products, className, holderClassName }: ProductsChipsProps) => {
  const params = useParams();
  const currentLanguage = getLanguageFromLocale(params.lang as string);

  return (
    <div className={className ? `${s.wrapper} ${className}` : s.wrapper}>
      <div className={s.divider}>
        <hr className={s.dividerLine} />
        <span className={s.dividerLabel}>
          <Status capitalize={false} text={productsText[currentLanguage]} variant='warning' />
        </span>
        <hr className={s.dividerTrail} />
      </div>
      <div className={holderClassName ? `${s.holder} ${holderClassName}` : s.holder}>
        {products.map(product => (
          <Status capitalize={false} className={s.chip} key={product.id} text={product.name[currentLanguage]} />
        ))}
      </div>
    </div>
  );
};
